import { InfoIcon } from "@phosphor-icons/react/Info";
import { Icon } from "@freightsimple/ui-core/Icons/Icon";
import { Link } from "@freightsimple/ui-core/Typography/Link";
import { Row } from "@freightsimple/ui-core/ComponentLayout/Row";
import { T } from "@freightsimple/ui-core/Typography/T";

function CreditCardsAddLegalease() {
  return (
    <Row gap={1.5} align="start">
      <Icon icon={InfoIcon} weight="fill" color="text-brand-text" size="sm" />
      <T size="xs" color="muted">
        Your credit card will not be billed until the shipment is finalized. If
        the shipment differs from the quote, this may result in additional
        charges.{" "}
        <Link
          external
          href="https://help.freightsimple.com/using-freightsimple/payments-and-invoices/additional-charges"
        >
          Learn More
        </Link>
      </T>
    </Row>
  );
}
export default CreditCardsAddLegalease;
